import { Classic } from "../types";

export const CLASSICS: Classic[] = [
  {
    id: 101,
    title: "Golden Hour Loop",
    subtitle: "Sunset views · Any park near you",
    emoji: "🌅",
    cardBg: "#FFF8F0", cardBorder: "#FFD9A8", accentColor: "#B5621E", tagBg: "#B5621E",
    distance: "2.4 mi", time: "38 min", steps: "~5,100 steps",
    neighbourhood: "Hyde Park, W2",
    vibe: "Catch the golden hour wherever you are. Find a bench. Feel cinematic.",
    playlistName: "Main Character Energy", playlistEmoji: "🌅",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX1BzILRveYHb",
    songs: ["Golden – Harry Styles", "Flowers – Miley Cyrus", "Levitating – Dua Lipa", "Waterloo Sunset – The Kinks", "Good Days – SZA"],
    bpm: "100 BPM · Chill Pop",
    waypoints: [
      { lat: 51.5073, lng: -0.1657, label: "Start: Hyde Park Corner" },
      { lat: 51.5057, lng: -0.1773, label: "The Serpentine" },
      { lat: 51.5051, lng: -0.1877, label: "Kensington Gardens" },
      { lat: 51.5119, lng: -0.1756, label: "Italian Gardens" },
      { lat: 51.5073, lng: -0.1657, label: "Finish: Hyde Park Corner" },
    ],
  },
  {
    id: 102,
    title: "Park Girlies Route",
    subtitle: "Green space · Total reset",
    emoji: "🌿",
    cardBg: "#F0FFF4", cardBorder: "#C8E6C9", accentColor: "#0A7C5E", tagBg: "#0A7C5E",
    distance: "1.8 mi", time: "28 min", steps: "~3,800 steps",
    neighbourhood: "Victoria Park, E9",
    vibe: "Trees, fresh air and zero drama. The most peaceful walk on the app.",
    playlistName: "Soft Girl Autumn", playlistEmoji: "🌿",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX9wC1KY45plY",
    songs: ["Heather – Conan Gray", "lovely – Billie Eilish", "August – Taylor Swift", "Cardigan – Taylor Swift", "Sweater Weather – The Neighbourhood"],
    bpm: "85 BPM · Soft Indie",
    waypoints: [
      { lat: 51.5361, lng: -0.0388, label: "Start: Victoria Park East" },
      { lat: 51.5372, lng: -0.0422, label: "The Lake" },
      { lat: 51.5389, lng: -0.0461, label: "Old English Garden" },
      { lat: 51.5361, lng: -0.0502, label: "Victoria Park West" },
      { lat: 51.5340, lng: -0.0437, label: "Finish: Grove Road" },
    ],
  },
  {
    id: 103,
    title: "The Power Walk",
    subtitle: "No excuses · Maximum slay",
    emoji: "💪",
    cardBg: "#FFF0F3", cardBorder: "#F5DDD9", accentColor: "#C9184A", tagBg: "#C9184A",
    distance: "4.0 mi", time: "60 min", steps: "~8,500 steps",
    neighbourhood: "South Bank, SE1",
    vibe: "You mean BUSINESS today. The longest, the hardest, the most iconic.",
    playlistName: "Hot Girl Summer", playlistEmoji: "💪",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX4dyzvuaRJ0n",
    songs: ["Run the World – Beyonce", "Power – Kanye West", "Savage – Megan Thee Stallion", "WAP – Cardi B", "Physical – Dua Lipa"],
    bpm: "140 BPM · Hype",
    waypoints: [
      { lat: 51.5055, lng: -0.0910, label: "Start: London Bridge" },
      { lat: 51.5072, lng: -0.1125, label: "South Bank" },
      { lat: 51.5074, lng: -0.1215, label: "Waterloo Bridge" },
      { lat: 51.5112, lng: -0.1246, label: "Covent Garden" },
      { lat: 51.5074, lng: -0.0994, label: "Tate Modern" },
      { lat: 51.5055, lng: -0.0910, label: "Finish: London Bridge" },
    ],
  },
  {
    id: 104,
    title: "Neighbourhood Glow",
    subtitle: "Quick and breezy · No excuse",
    emoji: "💨",
    cardBg: "#F3F0FF", cardBorder: "#D9D0F5", accentColor: "#5B45D4", tagBg: "#5B45D4",
    distance: "1.2 mi", time: "20 min", steps: "~2,500 steps",
    neighbourhood: "Old Street, EC1",
    vibe: "No time? No problem. Short, sweet and still counts.",
    playlistName: "That Girl Era", playlistEmoji: "💨",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX3rxVfibe1L0",
    songs: ["About Damn Time – Lizzo", "Confident – Demi Lovato", "Girl on Fire – Alicia Keys", "Run the World – Beyonce", "Dynamite – BTS"],
    bpm: "120 BPM · Pop Motivation",
    waypoints: [
      { lat: 51.5246, lng: -0.0865, label: "Start: Old Street Station" },
      { lat: 51.5261, lng: -0.0832, label: "Shoreditch High Street" },
      { lat: 51.5240, lng: -0.0789, label: "Hoxton Square" },
      { lat: 51.5246, lng: -0.0865, label: "Finish: Old Street Station" },
    ],
  },
  {
    id: 105,
    title: "The Thames Walk",
    subtitle: "River views · Total reset",
    emoji: "🌊",
    cardBg: "#F0F8FF", cardBorder: "#B3D9F5", accentColor: "#1565C0", tagBg: "#1565C0",
    distance: "3.0 mi", time: "48 min", steps: "~6,400 steps",
    neighbourhood: "Embankment to Tower Bridge, SE1",
    vibe: "London at its most cinematic. Walk along the Thames and feel everything.",
    playlistName: "London Dreaming", playlistEmoji: "🌊",
    spotifyUrl: "https://open.spotify.com/playlist/37i9dQZF1DX4OzrY981I1W",
    songs: ["River – Leon Bridges", "London Grammar – Hey Now", "Fix You – Coldplay", "The A Team – Ed Sheeran", "Skinny Love – Bon Iver"],
    bpm: "95 BPM · Cinematic Indie",
    waypoints: [
      { lat: 51.5074, lng: -0.1223, label: "Start: Embankment" },
      { lat: 51.5067, lng: -0.1125, label: "Waterloo Bridge" },
      { lat: 51.5074, lng: -0.0994, label: "Tate Modern" },
      { lat: 51.5055, lng: -0.0910, label: "London Bridge" },
      { lat: 51.5055, lng: -0.0752, label: "Finish: Tower Bridge" },
    ],
  },
];
